<template lang="pug">
.leftNav
  el-input(v-model="filterTextSys", size="small", placeholder="输入关键字进行过滤", clearable)
  el-tree.treeList.filter-tree(
    ref="tagTree",
    node-key="nodeId",
    :data="tagData",
    :props="tagRoleProps",
    :filter-node-method="filterNode",
    show-checkbox,
    @check="checkNodeChange",
    v-slot="{ node, data }"
  )
    node-icon(:node="node", type="Label") {{ data.tagName }}
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import NodeIcon from "./NodeIcon.vue";
export default {
  components: { NodeIcon },
  props: {
    // 选中的人员组件
    userList: { type: Array, default: () => [] }
  },
  data() {
    return {
      tagData: [], // 标签列表
      filterTextSys: "",
      tagRoleProps: {
        children: "children",
        label: "tagName"
      },
      nowSelect: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    defaultCheckedKeys() {
      return this.nowSelect?.map(({ nodeId }) => nodeId) || [];
    }
  },
  watch: {
    filterTextSys(val) {
      this.$refs.tagTree.filter(val);
    },
    userList: {
      immediate: true,
      async handler(val) {
        this.nowSelect = val;
        this.$refs.tagTree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    }
  },
  mounted() {
    this.queryTagList();
  },
  methods: {
    // 获取标签列表
    async queryTagList() {
      const res = await flowService.sysTagList(this.enterpriseId);
      this.tagData = res.data.map(e => { return { ...e, nodeId: e.tagId }; }) || [];
      if (this.nowSelect && this.nowSelect.length > 0) {
        await this.$nextTick();
        this.$refs.tagTree?.setCheckedKeys(this.defaultCheckedKeys);
      }
    },
    // 标签树形结构选择器
    checkNodeChange(data, currentChecked) {
      this.nowSelect = this.$refs.tagTree.getCheckedNodes();
      this.emitList();
    },
    // 给父级抛出选中的人员
    emitList() {
      const list = this.nowSelect.map((e) => {
        return {
          ...e,
          id: e.tagId,
          userId: e.tagId,
          name: e.tagName,
          selectName: e.tagName
        };
      });
      this.$emit("updateRight", "Label", list);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.tagName.indexOf(value) !== -1;
    }
  }
};
</script>

<style>
</style>
